module.exports = __webpack_public_path__ + "static/media/anzuum (1).c255a920.png";